import { render, staticRenderFns } from "./LivestockUpload.vue?vue&type=template&id=00f27117&"
import script from "./LivestockUpload.vue?vue&type=script&lang=js&"
export * from "./LivestockUpload.vue?vue&type=script&lang=js&"
import style0 from "./LivestockUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports